module.exports = __webpack_public_path__ + "media/images/fig_shortfall-a41471720dfd47e9ab0c5d4f497e190f.png";